import * as Sentry from "@sentry/react"
import { Suspense } from "react"
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom"

import { MainErrorFallback } from "@/components/errors/main"
import { DashboardLayout } from "@/components/layouts"
import { Spinner } from "@/components/ui/statuses"

export const AppRoot = () => {
  const location = useLocation()
  return (
    <DashboardLayout>
      <Sentry.ErrorBoundary
        key={location.pathname}
        fallback={<MainErrorFallback />}
      >
        <Suspense
          fallback={
            <div className="flex size-full items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <ScrollRestoration />
          <Outlet />
        </Suspense>
      </Sentry.ErrorBoundary>
    </DashboardLayout>
  )
}
